<template>
  <div class="BlockList" v-show="flog">
    <div class="BlockList-W">
      <div class="sign_close" @click="close">
        <img src="../../../assets/pc/Logo/close.png" />
      </div>
      <div class="signbox">
        <div class="sign_tit1">Sign In</div>
        <div class="sign_tit2">
          Don't have an account? <span @click="signup">Sign Up</span>
        </div>
        <div class="sign_form">
          <el-form ref="form" :model="form" :rules="rules">
            <div class="putext">
              <div class="puttit">Email</div>
              <el-form-item prop="email">
                <el-input
                  v-model="form.email"
                  class="inpttext"
                  placeholder="Enter your email address"
                ></el-input>
              </el-form-item>
            </div>
            <div class="putext">
              <div class="puttit">Password</div>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="form.password"
                  class="inpttext"
                  show-password
                  placeholder="Enter your password"
                ></el-input>

                <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
              </el-form-item>
            </div>
            <div class="password" @click="repassword">Forgot password?</div>
            <div class="putext" style="margin-top: 0px">
              <div class="puttit">Captcha</div>
              <div style="display: flex; justify-content: space-between">
                <!-- <div style="display: inline-block">
                  <verify
                    @success="onVerifySuccess"
                    @error="onVerifyError"
                    v-model="form.code"
                  ></verify>
                </div> -->
                <el-form-item prop="validCode">
                  <el-input
                    v-model="form.validCode"
                    class="inpttext"
                    style="width: 150px"
                    placeholder=""
                    size="medium"
                  ></el-input>
                </el-form-item>
                <Code @input="createValidCode"></Code>
              </div>
              <!-- <div style="display: inline-block">
                  <verify
                    @success="onVerifySuccess"
                    @error="onVerifyError"
                  ></verify>
                </div> -->
            </div>
            <div
              class="submit"
              :class="{ submit1: isFormValid() }"
              @click="login"
            >
              Log in
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verify from "vue2-verify";
import Signup from "@/views/pc/Login/Signup.vue";
import { login } from "@/assets/server/api";
import Code from "@/views/m/Login/code.vue";
export default {
  props: ["floag", "flogb", "flogc"],
  data() {
    return {
      isVerify: false,
      form: {
        email: "",
        password: "",
        repassword: "",
        validCode: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "password  is required",
            trigger: "change",
          },
          {
            min: 6,
            max: 12,
            message: "Please enter a password between 6 and 12 characters.",
            trigger: "blur",
          },
        ],
        validCode: [
          {
            required: true,
            message: "code is required",
            trigger: "change",
          },
        ],
      },
      flog: this.floag, //登录
      floagb: this.flogb, //注册
      floagc: this.flogc, //重置密码
      validCode: "",
    };
  },
  components: {
    Verify,
    Signup,
    Code,
  },
  created() {},
  mounted() {
    //this.login();
    var aa = localStorage.getItem("email");
  //  console.log(aa);
  },
  watch: {
    deep: true,
    floag(val) {
      this.flog = val;
      console.log(this.flog);
      this.$refs.form.clearValidate();
      this.form.email = "";
      this.form.password = "";
      this.form.validCode ="";
    },
  },
  methods: {
    isFormValid() {
      // Check if all required fields have values
      return (
        this.form.email.trim() !== "" &&
        this.form.password.trim() !== "" &&
        this.form.validCode.trim() !== ""
      );
    },
    createValidCode(data) {
      this.validCode = data;
 //     console.log(this.validCode);
    },
    //点击进行账号登录
    async login() {
   //   console.log(this.form.code);
      // this.onVerifySuccess();
      // if (this.isVerify == false) {
      //   this.$message("Captcha is required");
      //   return false;
      // } else {
      //   console.log();
      //   this.onVerifySuccess();

      // }
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
    //    console.log(this.form);
        if (success) {
          // if (!this.form.validCode) {
          //   this.$message.error("请填写验证码")
          //   return
          // }
          if (
            this.form.validCode.toLowerCase() !== this.validCode.toLowerCase()
          ) {
            this.$message.error("Error in verification code");
            return;
          }
          const params = {
            email: this.form.email,
            password: this.form.password,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await login(formData);
          console.log(data);
          if (data.code == 200) {
            console.log("登录成功");
            this.flog = false;
            localStorage.setItem("userId", data.result.userId);
            localStorage.setItem("email", data.result.email);
            localStorage.setItem("jwtToken", data.result.jwtToken);
            this.$emit("emails", data.result.email);
            this.$router.push("/m/Ownership");
            this.$router.push({
              path: "/m/Ownership",
              query: { userId: data.result.userId },
            });
            // this.flog1 = true;
            // this.flog = false;
            // this.emails = data.result;
          } else {
            // this.$message(data.result);
            this.$message({
              message: data.result,
              type: "warning",
              customClass: "message-zindex",
            });
          }
        } else {
         // this.$message(" This field are not filled in ");
         this.$message({
              message: data.result,
              type: "warning",
              customClass: "message-zindex",
            });
          return false;
        }
      });
    },
    //点击注册
    signup() {
      console.log(this.floagb);
      //this.flog = false;
      this.floagb = true;
      console.log(this.floagb);
      this.$emit("signups", this.floagb);
      console.log("点击注册");
      this.flog = false;
      this.$emit("loginflog", this.flog);
      this.$refs.form.clearValidate();
    },
    //点击重置密码
    repassword() {
      console.log("点击重置密码");
      console.log(this.floagc);
      this.floagc = true;
      this.$emit("repwd", this.floagc);
      this.flog = false;
      this.$emit("loginflog", this.flog);
      this.$refs.form.clearValidate();
    },
    //登录关闭
    close() {
      //this.flog=false;
      this.flog = false;
      this.form.email = "";
      this.form.password = "";
      this.form.validCode = "";
      this.$refs.form.clearValidate();
      this.$emit("loginflog", this.flog);
    },
    onVerifySuccess(obj) {
      this.isVerify = true;
      //验证码正确回调
      console.log("verify success");
      //todo
    },
    onVerifyError(obj) {
      this.isVerify = false;
      //验证码错误回调
      console.log("verify error");
      //错误刷新验证码
      obj.refresh();
      //todo
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
/deep/.el-input__inner {
  color: #ffffff !important;
}
/deep/.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 630px;
    height: 847px;
    background: #13161b;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .sign_close {
      margin-left: 558px;
      margin-top: 24px;
      img {
        width: 48px;
        height: 48px;
      }
    }
    .signbox {
      width: 550px;
      // border: 1px solid red;
      margin: 0 40px;
      margin-top: 24px;
      // text-align: center;

      .sign_tit1 {
        // width: 111px;
        height: 42px;
        font-size: 36px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }
      .sign_tit2 {
        height: 28px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        margin-top: 12px;
        span {
          color: #02d28e;
          cursor: pointer;
          margin-left: 8px;
        }
      }
      .sign_form {
        padding-top: 15px;
        .password {
          text-align: right;
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #ffffff;
          margin-top: -20px;
          cursor: pointer;
        }
        .putext {
          margin-bottom: 48px;
          .puttit {
            height: 33px;
            font-size: 28px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.5);
            line-height: 33px;
            margin-bottom: 12px;
          }
          /deep/.verify-change-code {
            display: none;
          }
          /deep/.verify-btn {
            display: none;
          }
          /deep/.cerify-code-panel {
            display: flex;
            // justify-content: space-between;
          }
          /deep/.verify-code {
            width: 338px !important;
            height: 80px !important;
            line-height: 80px !important;
            border-radius: 20px !important;
            border: none !important;
          }
          /deep/.varify-input-code {
            width: 180px;
            height: 80px;
            background: #000000;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 1px solid #000000;
            border: none;
            margin-left: 30px;
          }

          .password:hover {
            color: #02d28e;
            cursor: pointer;
          }
          .inpttext {
            width: 550px;
            height: 80px;
            background: #000000;
            border-radius: 12px 12px 12px 12px;
            opacity: 1;
            /deep/ .el-input__inner {
              background: #000000;
              border: none;
            }
          }
        }
        .submit {
          width: 550px;
          height: 80px;
          background: #333b3b;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          font-size: 28px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #858989;
          line-height: 80px;
          text-align: center;
          cursor: pointer;
          margin-top: -36px;
        }
        .submit1 {
          width: 550px;
          height: 80px;
          background: rgba(0, 231, 154, 0.9);
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          cursor: pointer;
          font-size: 28px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
        }
      }
    }
  }
}
</style>
